import { render, staticRenderFns } from "./CorrelationsPage.vue?vue&type=template&id=324c8fbe&scoped=true&"
import script from "./CorrelationsPage.vue?vue&type=script&lang=ts&"
export * from "./CorrelationsPage.vue?vue&type=script&lang=ts&"
import style0 from "./CorrelationsPage.vue?vue&type=style&index=0&id=324c8fbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324c8fbe",
  null
  
)

export default component.exports